<template>
  <div class="repairman backdrop">
    <div class="common repairman-search">
      <input type="text" v-model="search_input" placeholder="请输入姓名" @keyup.enter="search" @input="search($event)" />
      <img class="search-close" src="../../assets/images/repairman-search-close.png" @click="clean()">
      <div>搜索</div>
    </div>
    <div class="repairman-content">
      <div  class="common repairman-list" v-for="(r_keeper, r_keeper_key) in repair_keeper_list" :key="r_keeper_key"  >
        <div class="repairman-list-block" v-if="pan(r_keeper.id,member)" @click="selectRepairman(member,r_keeper.id, r_keeper.village_member_name, r_keeper.tel, r_keeper.head_portrait)">
          <img class="selectimg" src="../../assets/images/repairman-select.png">
          <img class="headimg" v-if="r_keeper.head_portrait !== ''" :src="r_keeper.head_portrait">
          <img class="headimg" v-if="r_keeper.head_portrait == ''" src="../../assets/images/no-pictures.png">
          <div class="message">
            <span>{{r_keeper.village_member_name}}{{r_keeper.tel}}</span>
            <span>{{r_keeper.tel}}</span>
          </div>
          <div class="singular"><span>{{r_keeper.num}}</span>单</div>
        </div>
        <div class="repairman-list-block" v-else style="background-color:#ccc">
          <img class="selectimg" src="../../assets/images/repairman-select.png">
          <img class="headimg" :src="r_keeper.head_portrait">
          <img class="headimg" v-if="r_keeper.head_portrait == ''" src="../../assets/images/no-pictures.png">
          <div class="message">
            <span>{{r_keeper.village_member_name}}{{r_keeper.tel}}</span>
            <span>{{r_keeper.tel}}</span>
          </div>
          <div class="singular"><span>{{r_keeper.num}}</span>单</div>
        </div>
        <div class="repair-order-list" v-if="repairstatistics" v-for="(appointlist, appointlist_key) in r_keeper.appoint_list" :key="appointlist_key">
          <div class="repair-order-title">
            <span class="type_name">{{appointlist.repair_type_name}}-</span>
            <span class="phone_name" style="color: #8c8c8c;">{{appointlist.repair_people_name}}</span>
          </div>
          <div class="repair-order-describe">{{appointlist.repair_summary}}</div>
          <div class="repair-order-detail">
            <div class="marker_time">{{appointlist.create_time}}</div>
            <div style="margin-left: 10px;" class="marker_block" v-if="appointlist.clock_time == 0" >未开始</div>
            <div style="margin-left: 10px;" class="marker_chunk" v-if="appointlist.clock_time !== 0" >工作中</div>
          </div>
        </div>
      </div>
    </div>
    <div class="repairman-button" @click="expandRepair">{{expandrepair}}</div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'SelectRepairman',
  metaInfo: {
    title: '选择维修师傅'
  },
  data () {
    return {
      repair_keeper_list: [],
      // member: [],
      name: 'search',
      search_list: [],
      newarray: [],
      search_input: '',
      expandrepair: '查看工作内容',
      repairstatistics: false,
      expandrepairflag: 0
    }
  },
  computed: {
    ...mapState(['villageId'])
  },
  created () {
    this.getRepairKeeper()

    this.num_m = this.$route.params.num_m
    this.member = this.$route.query.member
  },
  methods: {
    getRepairKeeper () {
      this.axios.get('/wechat/repair/getRepairKeeper/village_id/' + this.villageId)
        .then((res) => {
          if (res.data.status === 1) {
            this.repair_keeper_list = res.data.data
            this.search_list = res.data.data
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 选择维修师傅
    selectRepairman: function (newarray, id, name, tel, headportrait) {
      this.$router.replace({name: 'Repairman', query: {newarray: newarray, id: id, name: name, tel: tel, head_portrait: headportrait}})
    },
    pan: function (id, member) {
      let newarray = []
      if (member !== undefined) {
        newarray = JSON.parse(member)
      } else {
        newarray = []
      }
      for (let i = 0; i < newarray.length; i++) {
        if (newarray[i].id === id) {
          return false
        }
      }
      return true
    },
    fuzzyMatch: function (str, key) {
      let index = -1
      let flag = false
      for (var i = 0, arr = key.split(''); i < arr.length; i++) {
        // 有一个关键字都没匹配到，则没有匹配到数据
        if (str.indexOf(arr[i]) < 0) {
          break
        } else {
          let match = str.matchAll(arr[i])
          let next = match.next()
          while (!next.done) {
            if (next.value.index > index) {
              index = next.value.index
              if (i === arr.length - 1) {
                flag = true
              }
              break
            }
            next = match.next()
          }
        }
      }
      console.log(flag)
      return flag
    },
    search: function (event) {
      if (event.currentTarget.value.length === 0) {
        this.repair_keeper_list = this.search_list
      } else {
        this.repair_keeper_list = []
        for (let i = 0; i < this.search_list.length; i++) {
          if (this.fuzzyMatch(this.search_list[i].village_member_name, event.currentTarget.value)) {
            this.repair_keeper_list.splice(i, 0, this.search_list[i])
          }
        }
      }
    },
    clean: function () {
      this.search_input = ''
      this.repair_keeper_list = this.search_list
    },
    expandRepair: function () {
      if (this.expandrepairflag === 0) {
        this.expandrepair = '收起工作内容'
        this.repairstatistics = true
        this.expandrepairflag = 1
      } else {
        this.expandrepair = '查看工作内容'
        this.repairstatistics = false
        this.expandrepairflag = 0
      }
    }
  }

}
</script>
<style scoped>
.repairman-search {
  display: flex;
  position: relative;
}
.repairman-search input {
  flex: 1;
  height: 27px;
  background-color: #f8f8f8;
  border-radius: 14px;
  border: none;
  padding: 0 28px 0 30px;
  background-image: url(../../assets/images/repairman-search.png);
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: 9px center;
}
.repairman-search div {
  font-size: 14px;
  color: #000000;
  padding-left: 20px;
  line-height: 27px;
}
.repairman-search img {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 20px;
  right: 72px;
}
.repairman-content {
  padding-bottom: 50px;
}
.repairman-content .repairman-list {
  padding: 5px 15px;
}
.repairman-content .repairman-list .repairman-list-block {
  display: flex;
  padding: 10px 0;
}
.repairman-content .repairman-list .repairman-list-block .message {
  flex: 1;
  color: #000000;
  padding: 0 15px;
}
.repairman-content .repairman-list .repairman-list-block .message span {
  display: block;
}
.repairman-content .repairman-list .repairman-list-block .message span:first-child {
  font-size: 15px;
  padding-top: 9px;
}
.repairman-content .repairman-list .repairman-list-block .message span:last-child {
  font-size: 12px;
  color: #8c8c8c;
  padding-top: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.repairman-content .repairman-list .repairman-list-block .headimg {
  width: 59px;
  height: 59px;
  border-radius: 50%;
}
.repairman-content .repairman-list .repairman-list-block .selectimg {
  width: 23px;
  height: 23px;
  margin: 18px 15px 0 0;
}
.repairman-content .repairman-list .singular {
  font-size: 15px;
  line-height: 59px;
}
.repairman-content .repairman-list .singular span {
  font-size: 18px;
}
.repairman-content .repairman-list .repair-order-list {
  margin: 6px 0;
  color: #313131;
  font-size: 15px;
  background-color: #f5f5f5;
  padding: 5px 10px;
}
.repairman-content .repairman-list .repair-order-list .repair-order-title {
  align-items: center;
  justify-content: center;
}
.repairman-content .repairman-list .repair-order-list .repair-order-title .type_name {
  font-size: 16px;
  letter-spacing: 2px;
  font-weight: bold;
}
.repairman-content .repairman-list .repair-order-list .repair-order-title .phone_name {
  padding-right: 8px;
  line-height: 19px;
}
.repairman-content .repairman-list .repair-order-list .repair-order-describe {
  margin: 6px 0 8px 0;
}
.repairman-content .repairman-list .repair-order-list .repair-order-detail {
  display: flex;
  color: #8c8c8c;
}
.repairman-content .repairman-list .repair-order-list .repair-order-detail .marker_block {
  margin-left: 100px;
  text-align: center;
  background-color: #ffffff;
  color: #fa6b2c;
  padding: 0 10px;
  border-radius: 12px;
}
.repairman-content .repairman-list .repair-order-list .repair-order-detail .marker_chunk {
  margin-left: 100px;
  text-align: center;
  background-color: #35c53b;
  color: #ffffff;
  padding: 0 10px;
  border-radius: 12px;
}
.repairman-button {
  width: 100%;
  text-align: center;
  position: fixed;
  bottom: 0;
  padding: 15px 0;
  background-color: #ff7c12;
}
</style>



// WEBPACK FOOTER //
// src/components/Repair/SelectRepairman.vue